import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatCurrency(value, decimals = 2) {
  if (value === null || value === undefined) return '$0.' + '0'.repeat(decimals);
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals
  }).format(value);
}

export function formatPercent(value) {
  if (value === null || value === undefined) return '0%';
  return (value * 100).toFixed(2) + '%';
}

// Format percentage without decimals (for split percentages that are typically whole numbers)
export function formatPercentClean(value) {
  if (value === null || value === undefined) return '0%';
  const pct = value * 100;
  // Show decimals only if needed
  return pct % 1 === 0 ? pct.toFixed(0) + '%' : pct.toFixed(1) + '%';
}

export function formatDate(dateString) {
  if (!dateString) return '';
  
  // Handle date strings in YYYY-MM-DD format (with or without time) without timezone conversion
  // This prevents the off-by-one day issue caused by UTC conversion
  if (typeof dateString === 'string') {
    const match = dateString.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (match) {
      const [, year, month, day] = match;
      const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day)); // month is 0-indexed
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
      });
    }
  }
  
  // For other date formats, use standard parsing
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return '';
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
}

export function formatCompactCurrency(value) {
  if (value === null || value === undefined) return '$0';
  if (value >= 1000000) {
    return '$' + (value / 1000000).toFixed(1) + 'M';
  }
  if (value >= 1000) {
    return '$' + (value / 1000).toFixed(1) + 'K';
  }
  return '$' + value.toFixed(0);
}
